import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgRedeemFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.3929 9.056L13.7849 10.2L14.3849 12.08C14.5209 12.488 14.4489 12.96 14.1849 13.36C13.7129 14.032 12.8489 14.168 12.1769 13.696L10.6409 12.552L9.09693 13.696C8.66493 14.072 8.04093 14.096 7.52893 13.76H5.88893C3.21693 13.76 1.87293 13.76 0.936926 12.824C0.000926197 11.88 0.000926224 10.536 0.000926224 7.848V6.504C0.000926224 4.752 -0.0630738 3.88 0.872926 2.944C1.80893 2 3.14493 2 5.82493 2H8.49693C11.1769 2 12.5129 2 13.4489 2.944C14.0569 3.6 14.3129 4.448 14.3209 5.792V6.504H14.5209C15.1209 6.504 15.6569 6.904 15.8569 7.512C16.0649 8.112 15.9209 8.72 15.3929 9.056Z" />
    <path
      d="M6.36082 10.608C6.36082 10.944 6.08882 11.144 5.82482 11.144H3.14482C2.80882 11.144 2.60882 10.944 2.60882 10.608C2.60882 10.272 2.88082 10.064 3.14482 10.064H5.82482C6.16082 10.064 6.36082 10.264 6.36082 10.608Z"
      fill="white"
    />
    <path
      d="M4.34482 6.488C4.34482 6.824 4.07282 7.024 3.80882 7.024H1.12882C0.79282 7.024 0.59282 6.824 0.59282 6.488C0.59282 6.152 0.86482 5.944 1.12882 5.944H3.80882C4.14482 5.944 4.34482 6.144 4.34482 6.488Z"
      fill="white"
    />
    <path
      d="M15.1448 7.936C15.1448 7.672 14.9448 7.4 14.6088 7.4H12.3288C12.1288 7.4 11.9288 7.264 11.9288 7.064L11.2648 4.912C11.1928 4.776 11.1288 4.576 10.9288 4.576C10.6568 4.44 10.3288 4.64 10.2568 4.912L9.59282 7.064C9.52082 7.264 9.39282 7.4 9.18482 7.4H6.91282C6.71282 7.4 6.57682 7.464 6.44882 7.6C6.31282 7.8 6.31282 8.136 6.57682 8.344L8.44882 9.688C8.58482 9.752 8.58482 9.952 8.58482 10.16L7.84882 12.304C7.78482 12.44 7.78482 12.64 7.92082 12.776C8.04882 13.048 8.38482 13.112 8.65682 12.912L10.4568 11.568C10.5928 11.432 10.8648 11.432 10.9928 11.568L12.8008 12.912C12.9368 12.976 13.1368 12.976 13.2728 12.976C13.6008 12.912 13.6728 12.576 13.6008 12.304L12.9368 10.16C12.8648 10.024 12.9368 9.824 13.0648 9.688L14.9448 8.344C15.0728 8.208 15.1448 8.136 15.1448 7.936Z"
      fill="white"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgRedeemFilled)
const IconSvgRedeemFilled = createIcon(ForwardRef, 'SvgRedeemFilled')
export default IconSvgRedeemFilled
